/* eslint-disable camelcase */
import React, { useContext } from 'react'
import { Helmet } from 'react-helmet'
// import { useHistory } from 'react-router-dom'
import userManager from 'App/util/UserManager'
import { ApplicationContext } from 'App/context'
import Loader from 'App/components/Loader'

export const LogoutPage = () => {
  const ctx = useContext(ApplicationContext)

  // const history = useHistory()
  React.useEffect(() => {
    console.log('Hootsuite App - removing user..')
    userManager
      .removeUser()
      .then(() => {
        console.log('Hootsuite App - Logout')
        if (ctx !== undefined && ctx.extraQueryParams !== undefined) {
          window.sessionStorage.setItem('hootsuiteUserId', ctx.extraQueryParams.hootsuiteUserId)
          window.sessionStorage.setItem('hootsuiteTimestamp', ctx.extraQueryParams.hootsuiteTimestamp)
          window.sessionStorage.setItem('hootsuitePlacementId', ctx.extraQueryParams.hootsuitePlacementId)
          window.sessionStorage.setItem('hootsuiteToken', ctx.extraQueryParams.hootsuiteToken)
          window.sessionStorage.setItem('messageId', ctx.extraQueryParams.messageId)
        }

        let id_token_hint
        if (ctx !== undefined && ctx.extraQueryParams !== undefined && ctx.extraQueryParams.hootsuiteUserId !== undefined) {
          console.log(`hootsuite user id for logout: ${ctx.extraQueryParams.hootsuiteUserId}`)
          id_token_hint = ctx.extraQueryParams.hootsuiteUserId
        }

        userManager.signoutRedirect({ extraQueryParams: ctx.extraQueryParams, id_token_hint }).catch((reason) => {
          console.error('signoutRedirect() Error caught', reason)
        })
      })
      .catch((reason) => {
        console.error('removeUser() Error caught:', reason)
      })
  }, [])

  return (
    <>
      <Helmet title="Logout" />
      <Loader />
    </>
  )
}

export default {
  name: 'Logout',
  routeProps: {
    path: '/logout',
    component: LogoutPage
  },
}
